import { UserClassModel } from '@/models/class/class';
import { SubjectModel } from '@/models/taxonomy/subject';
import { journeyAPI } from '@/providers/apis/journey/journey';
import { sessionService } from '@/providers/services/auth/session';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'journey-list-panel',
})

export default class  JourneyListPanelComponent extends Vue {


    // ----------------------------------------------------------------
    // Properties

    @Prop()
    private userClassList!: UserClassModel[];

    @Prop()
    private activeFacets!: SubjectModel[];

    @Prop()
    private userId!: string;

    private activeSubject: any = {};


    // ----------------------------------------------------------------
    // Hooks

    private created() {
        this.activeSubject = this.activeFacets[0];
        this.loadData();
    }


    // ----------------------------------------------------------------
    // Actions

    private onSelectSubject(subject: SubjectModel) {
        this.activeSubject = subject;
        this.loadData();
    }


    // ----------------------------------------------------------------
    // Methods

    private loadData() {
        const activeSubject = this.activeSubject;
        const userClassList = this.userClassList;
        const filterSubjectClass = userClassList.filter((classItem) => classItem.subject === activeSubject.code);
        this.$set(activeSubject, 'classList', [...filterSubjectClass]);
        this.fetchClassPerformance(activeSubject.classList);
    }

    private fetchClassPerformance(filteredClass: UserClassModel[]) {
        const userId = this.userId;
        const params = {
            classes: filteredClass.map((item) =>  {
                return {
                    courseId: item.courseId,
                    classId: item.id,
                };
            }),
        };
        if (params.classes.length) {
            journeyAPI.fetchClassPerformance(params, userId).then((performances) => {
                filteredClass.forEach((item) => {
                    const classPerformance = performances.find((performance: any) => item.id === performance.classId);
                    this.$set(item, 'performance', classPerformance);
                });
            });
        }
    }




}
